import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC9wzVUBWotj2gdeRypfsVbneJgM7nB7a0",
  authDomain: "portfolioshaheer-cd406.firebaseapp.com",
  projectId: "portfolioshaheer-cd406",
  storageBucket: "portfolioshaheer-cd406.firebasestorage.app",
  messagingSenderId: "452064885321",
  appId: "1:452064885321:web:7f1a0bbb6aa05516e69d98",
  measurementId: "G-2G029MWSRC"
};


const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
